export default {"src":"/_next/static/media/loading-wheel.53ec60cd.gif","height":300,"width":394,"blurWidth":0,"blurHeight":0};